
import * as React from 'react'
import { Image, Text, View, TouchableOpacity, ScrollView, ActivityIndicator } from 'react-native'
import images from '../../assets/images'
import { useTheme } from '@react-navigation/native'
import moment from 'moment'
import AnimatedProgressWheel from 'react-native-progress-wheel';
import Axios from 'axios'
import { RefreshControl } from 'react-native-web-refresh-control'

export default React.memo(function ProcessDay({ day_string }) {
    const { colors } = useTheme()
    const [data, setData] = React.useState()
    const [refreshing, setRefreshing] = React.useState(true)

    React.useEffect(() => {
        setRefreshing(true)
        Axios.get(`/api/ceo/operations?type=1&day=${moment(day_string, 'DD/MM/YYYY').format('YYYY-MM-DD')}`)
            .then(res => {
                console.log(res)
                if (res.status === 200)
                    setData(res.data.data)
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }, [day_string])

    const getColorProgress = (value) => {
        try {
            if (value < 50) return colors.process_3
            else if (value < 75) return colors.process_1
            else return colors.process_2
        } catch (error) {
        }
    }

    const getColorText = (value) => {
        try {
            if (value < 50) return colors.text_red
            else if (value < 75) return colors.text_yellow
            else return colors.text_green
        } catch (error) {
        }
    }

    const onRefresh = () => {
        setRefreshing(true)
        Axios.get(`/api/ceo/operations?type=1&day=${moment(day_string, 'DD/MM/YYYY').format('YYYY-MM-DD')}`)
            .then(res => {
                console.log(res)
                if (res.status === 200) {
                    setData(res.data.data)
                }
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }

    const percent_tmp = data?.daily_no_valid_driver_allocated_trips && data?.count_trip ?
        data?.daily_no_valid_driver_allocated_trips / data?.count_trip * 100 : 0
    const percent_valid = Math.round(percent_tmp * 100) / 100

    return (
        <ScrollView style={{ flex: 1 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={colors.text} colors={[colors.text]} />}>
            {
                data ? <>
                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'column', alignItems: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text }}>DOANH THU / KM KẾ HOẠCH</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 32, color: colors.text }}>{data?.revenue?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                        </View>
                        <View style={{ flexDirection: 'row', marginBottom: 16, marginTop: 12 }}>
                            <View style={{
                                height: 28, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.ratio_revenue > 100 ? 100 : data?.ratio_revenue}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.ratio_revenue), borderRadius: 3
                                }} />
                                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6 }}>{data?.ratio_revenue}% kế hoạch</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{ flexDirection: 'row', paddingHorizontal: 12, marginTop: 18 }}>
                        <View style={{ flex: 1, backgroundColor: 'white', borderRadius: 10, paddingHorizontal: 12, paddingTop: 8, paddingBottom: 12, flexDirection: 'column' }}>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <Text style={{ fontSize: 11, fontFamily: 'Nunito_700Bold', color: colors.text, width: 60 }}>Lượt xe</Text>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text, lineHeight: 28 }}>{data?.count_trip?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 6, alignItems: 'center' }}>
                                <Image source={images.icons.icon_bus} style={{ width: 35, height: 35, resizeMode: 'contain', marginRight: 26 }} />
                                <View style={{ flexDirection: 'column', flex: 1 }}>
                                    <View style={{
                                        height: 25, position: 'relative', backgroundColor: colors.process_background, borderRadius: 3,
                                        justifyContent: 'center'
                                    }}>
                                        <View style={{
                                            position: 'absolute', top: 0, left: 0, width: `${data?.ratio_trip_ago > 100 ? 100 : data?.ratio_trip_ago}%`,
                                            height: '100%', backgroundColor: getColorProgress(data?.ratio_trip_ago), borderRadius: 3
                                        }} />
                                        <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6, fontSize: 8 }}>{data?.ratio_trip_ago}% tuần trước</Text>
                                        </View>
                                    </View>
                                    <View style={{
                                        height: 25, position: 'relative', backgroundColor: colors.process_background, borderRadius: 3,
                                        justifyContent: 'center', marginTop: 8
                                    }}>
                                        <View style={{
                                            position: 'absolute', top: 0, left: 0, width: `${data?.ratio_trip_plan > 100 ? 100 : data?.ratio_trip_plan}%`,
                                            height: '100%', backgroundColor: getColorProgress(data?.ratio_trip_plan), borderRadius: 3
                                        }} />
                                        <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6, fontSize: 8 }}>{data?.ratio_trip_plan}% kế hoạch</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={{ width: 16 }}></View>

                        <View style={{ flex: 1, backgroundColor: 'white', borderRadius: 10, paddingHorizontal: 12, paddingTop: 8, paddingBottom: 12, flexDirection: 'column' }}>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <Text style={{ fontSize: 11, fontFamily: 'Nunito_700Bold', color: colors.text, width: 60 }}>Lượt khách</Text>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text, lineHeight: 28 }}>{data?.count_passenger?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 6, alignItems: 'center' }}>
                                <Image source={images.icons.icon_person} style={{ width: 35, height: 35, resizeMode: 'contain', marginRight: 26 }} />
                                <View style={{ flexDirection: 'column', flex: 1 }}>
                                    <View style={{
                                        height: 25, position: 'relative', backgroundColor: colors.process_background, borderRadius: 3,
                                        justifyContent: 'center'
                                    }}>
                                        <View style={{
                                            position: 'absolute', top: 0, left: 0, width: `${data?.ratio_passenger_ago > 100 ? 100 : data?.ratio_passenger_ago}%`,
                                            height: '100%', backgroundColor: getColorProgress(data?.ratio_passenger_ago), borderRadius: 3
                                        }} />
                                        <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6, fontSize: 8 }}>{data?.ratio_passenger_ago}% tuần trước</Text>
                                        </View>
                                    </View>
                                    <View style={{
                                        height: 25, position: 'relative', backgroundColor: colors.process_background, borderRadius: 3,
                                        justifyContent: 'center', marginTop: 8
                                    }}>
                                        <View style={{
                                            position: 'absolute', top: 0, left: 0, width: `${data?.ratio_passenger_plan > 100 ? 100 : data?.ratio_passenger_plan}%`,
                                            height: '100%', backgroundColor: getColorProgress(data?.ratio_passenger_plan), borderRadius: 3
                                        }} />
                                        <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', justifyContent: 'center' }}>
                                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', paddingHorizontal: 6, fontSize: 8 }}>{data?.ratio_passenger_plan}% kế hoạch</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{
                        backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15,
                        paddingVertical: 8
                    }}>
                        <View style={{ position: 'relative', flexDirection: 'row', alignItems: 'center' }}>
                            <View style={{ flexDirection: 'column', flex: 1 }}>
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 12, marginLeft: 5 }}>Khách bình quân lượt</Text>
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 24, marginLeft: 5, marginTop: 4 }}>{data?.ratio_fill}</Text>
                                <Text style={{ color: colors.text, fontSize: 10, marginLeft: 5 }}>khách / lượt</Text>
                            </View>
                            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-end' }}>
                                <View style={{ flexDirection: 'column' }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 12, marginBottom: 3 }}>Hệ số lấp đầy</Text>
                                    <View style={{ position: 'relative', flexDirection: 'row', justifyContent: 'center' }}>
                                        <AnimatedProgressWheel
                                            size={50}
                                            width={6}
                                            color={getColorProgress(data?.ratio_equivalent)}
                                            backgroundColor={colors.process_background}
                                            progress={parseFloat(data?.ratio_equivalent)}
                                            animateFromValue={0}
                                            duration={3000}
                                        />
                                        <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0 }}>
                                            <Text style={{
                                                fontFamily: 'Nunito_700Bold', color: getColorText(data?.ratio_equivalent),
                                                fontSize: 10, textAlign: 'center'
                                            }}>{data?.ratio_equivalent}%</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                            <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0 }}>
                                <Text style={{ color: colors.text, fontSize: 11, marginTop: 3 }}>Tương đương với</Text>
                            </View>
                        </View>
                    </View>

                    <View style={{ flexDirection: 'row', marginHorizontal: 12, marginTop: 18 }}>
                        <View style={{
                            backgroundColor: 'white', borderRadius: 10, paddingHorizontal: 10, flexDirection: 'column', flex: 1
                        }}>
                            <View style={{ paddingTop: 4, paddingBottom: 6 }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <View style={{ backgroundColor: '#96C0FF', borderRadius: 3, width: 8, height: 8 }} />
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 11, marginLeft: 7, lineHeight: 20 }}>
                                        Huỷ không lái <Text style={{ fontSize: 14, color: '#96C0FF', fontFamily: 'Nunito_700Bold' }}>{data?.canceld_trip_driver?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text> lượt
                        </Text>
                                </View>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <View style={{ backgroundColor: '#F28F8F', borderRadius: 3, width: 8, height: 8 }} />
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 11, marginLeft: 7, lineHeight: 20 }}>
                                        Huỷ có lái <Text style={{ fontSize: 14, color: '#F28F8F', fontFamily: 'Nunito_700Bold' }}>{data?.canceld_trip_driver_exists?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text> lượt
                        </Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row', paddingBottom: 9 }}>
                                <View style={{
                                    height: 7, borderRadius: 3, backgroundColor: '#96C0FF',
                                    width: data?.canceld_trip_driver || data?.canceld_trip_driver_exists ?
                                        (data?.canceld_trip_driver / (data?.canceld_trip_driver + data?.canceld_trip_driver_exists)) * 100 + '%' : '0%'
                                }} />
                                <View style={{ width: 2 }} />
                                <View style={{
                                    height: 7, borderRadius: 3, backgroundColor: '#F28F8F',
                                    width: data?.canceld_trip_driver || data?.canceld_trip_driver_exists ?
                                        (data?.canceld_trip_driver_exists / (data?.canceld_trip_driver + data?.canceld_trip_driver_exists)) * 100 + '%' : '0%'
                                }} />
                            </View>
                        </View>
                        <View style={{ width: 16 }} />
                        <View style={{
                            backgroundColor: 'white', borderRadius: 10, paddingHorizontal: 10, flexDirection: 'column', flex: 1
                        }}>
                            <View style={{ paddingTop: 4, paddingBottom: 6 }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <View style={{ backgroundColor: '#30E0A1', borderRadius: 3, width: 8, height: 8 }} />
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 11, marginLeft: 7, lineHeight: 20 }}>
                                        Xe tốt <Text style={{ fontSize: 14, color: '#30E0A1', fontFamily: 'Nunito_700Bold' }}>{data?.daily_no_good_cars?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text> xe
                        </Text>
                                </View>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <View style={{ backgroundColor: '#F28F8F', borderRadius: 3, width: 8, height: 8 }} />
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 11, marginLeft: 7, lineHeight: 20 }}>
                                        Xe nằm <Text style={{ fontSize: 14, color: '#F28F8F', fontFamily: 'Nunito_700Bold' }}>{data?.daily_no_unused_cars?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text> xe
                        </Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row', paddingBottom: 9 }}>
                                <View style={{
                                    height: 7, borderRadius: 3, backgroundColor: '#30E0A1',
                                    width: data?.daily_no_good_cars || data?.daily_no_unused_cars ?
                                        (data?.daily_no_good_cars / (data?.daily_no_good_cars + data?.daily_no_unused_cars)) * 100 + '%' : '0%'
                                }} />
                                <View style={{ width: 2 }} />
                                <View style={{
                                    height: 7, borderRadius: 3, backgroundColor: '#F28F8F',
                                    width: data?.daily_no_good_cars || data?.daily_no_unused_cars ?
                                        (data?.daily_no_unused_cars / (data?.daily_no_good_cars + data?.daily_no_unused_cars)) * 100 + '%' : '0%'
                                }} />
                            </View>
                        </View>
                    </View>

                    <View style={{
                        backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15, flexDirection: 'column',
                        justifyContent: 'center', paddingVertical: 12
                    }}>
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={{ color: colors.text, fontSize: 15, fontFamily: 'Nunito_700Bold' }}>
                                Định biên đúng lái: <Text style={{ color: '#44C4A1', fontSize: 18 }}>{data?.daily_no_valid_driver_allocated_trips?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </Text>
                                <Text style={{ color: '#8F99BA', fontSize: 18 }}>/</Text>
                                <Text style={{ color: colors.text, fontSize: 18 }}> {(data?.count_trip)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text> lượt</Text>
                        </View>
                        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 4 }}>
                            <Text style={{ width: 55, fontFamily: 'Nunito_700Bold', color: colors.text }}>
                                {percent_valid}%
                    </Text>
                            <View style={{ flexDirection: 'row', flex: 1 }}>
                                <View style={{
                                    height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                    justifyContent: 'center'
                                }}>
                                    <View style={{
                                        position: 'absolute', top: 0, left: 0, width: `${percent_valid > 100 ? 100 : percent_valid}%`,
                                        height: '100%', backgroundColor: getColorProgress(percent_valid), borderRadius: 3
                                    }} />
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{ marginBottom: 16 }} />
                </>
                    : (
                        !refreshing ? <View style={{ marginTop: 80, flexDirection: 'column', alignItems: 'center' }}>
                            <Image source={images.server_error} style={{ width: 200, height: 200 }} />
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginTop: 24, fontSize: 18 }}>Đã có lỗi xảy ra</Text>
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Vui lòng ấn nút bên dưới để thử lại</Text>
                            <TouchableOpacity onPress={onRefresh}>
                                <Image source={images.refresh} style={{ width: 40, height: 40, marginTop: 16 }} />
                            </TouchableOpacity>
                        </View> : null
                    )
            }
        </ScrollView>
    );
})